/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassEnrollRequest
 */
export interface ClassEnrollRequest {
    /**
     * 
     * @type {string}
     * @memberof ClassEnrollRequest
     */
    classId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassEnrollRequest
     */
    studentEmails: Array<string>;
}

/**
 * Check if a given object implements the ClassEnrollRequest interface.
 */
export function instanceOfClassEnrollRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "studentEmails" in value;

    return isInstance;
}

export function ClassEnrollRequestFromJSON(json: any): ClassEnrollRequest {
    return ClassEnrollRequestFromJSONTyped(json, false);
}

export function ClassEnrollRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassEnrollRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'studentEmails': json['studentEmails'],
    };
}

export function ClassEnrollRequestToJSON(value?: ClassEnrollRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'studentEmails': value.studentEmails,
    };
}

